import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Box from '@ntuctech/devex-tangram/Box';

const multipleActionStyle = `
  justify-content: end;
  flex-direction: row-reverse;

  & button._ndsBtn--compact {
    margin-left: 0.5rem !important;
  }
`;

const FormActionsSC = styled(Box)`
  justify-content: center;
  display: flex;
  flex-wrap: wrap;

  button._ndsBtn--compact,
  button._ndsBtn--compact._ndsBtn--fluid {
    margin: 0;
  }

  ${(p) => (p.multipleActions ? multipleActionStyle : '')}
`;

const FormActions = ({ children, spacing: spacingProp, ...rest }) => {
  const defaultSpacing = { mt: 2, mb: 0 };
  const spacing = { ...defaultSpacing, ...spacingProp };

  return (
    <FormActionsSC {...spacing} {...rest}>
      {children}
    </FormActionsSC>
  );
};

FormActions.defaultProps = {
  spacing: {},
};

FormActions.propTypes = {
  children: PropTypes.node.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  spacing: PropTypes.object,
};

export default FormActions;
